import { useState } from "react"
import axiosInstance from "../../services/axios-client"
import { toast } from "react-toastify"

const useForgotPassword = () => {
    const [payload, setPayload] = useState({})
    const onChangeHandler= (e)=>{
        setPayload({...payload,[e.target.name]:e.target.value})
    }
    
    const [loadingPagestate, setLoadingPage] = useState(false)

    const forgotPasswordHandler = async() => {
        try {
            setLoadingPage(true)
            const res = await axiosInstance.post(`/forget-password`, payload)
            if (res.status == 200) {
                setLoadingPage(false)
                toast.success("Check your email for reset password")
            }
        } catch (error) {
            setLoadingPage(false)
            if(error.response)
            toast.error(error.response.data.status.description)
            else toast.error(error.message)
        }
    }

    return {
        payload,
        onChangeHandler,
        forgotPasswordHandler,
        loadingPagestate
    }
}

export default useForgotPassword